import { useTranslation } from "react-i18next";
import process1 from "../../Visualizing/LandingPage/designstudio_process_1.png";
import process2 from "../../Visualizing/LandingPage/designstudio_process_2.png";
import process3 from "../../Visualizing/LandingPage/designstudio_process_3.png";
import styles from "../Styles/Sections.module.css";
import { ArrowRightIcon } from "@radix-ui/react-icons";

function ProcessSection() {
  const { t } = useTranslation();
  return (
    <div className={styles.processSection}>
      <div className={styles.processImageContainer}>
        <div className={styles.processImageCard}>
          <img
            width="270"
            height="220"
            src={process1}
            style={{ alignSelf: "center" }}
            alt="Illustrasjon av Woolit Design Studio Pro"
          />
          <div className={styles.processImageDescription}>
            <div className={styles.processIcon}>1</div>
            <div>
              {t("landing.create designs in WDS")}
              <br></br>
            </div>
          </div>
        </div>

        <div className={styles.processImageCard}>
          <img
            width="270"
            height="220"
            src={process2}
            style={{ alignSelf: "center" }}
            alt="Strikket genser og oppskrift  til salg."
          />
          <div className={styles.processImageDescription}>
            <div className={styles.processIcon}>2</div>
            <div>
              {t("landing.publish with one click")}
              <br></br>
              <a
                href="https://shop.woolit.no"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "var(--contrast" }}
              >
                {t("landing.explore shop")}{" "}
                <ArrowRightIcon
                  style={{ marginBottom: "-3px" }}
                ></ArrowRightIcon>
              </a>
            </div>
          </div>
        </div>

        <div className={styles.processImageCard}>
          <img
            width="270"
            height="220"
            src={process3}
            style={{ alignSelf: "center" }}
            alt="Jordkloden"
          />
          <div className={styles.processImageDescription}>
            <div className={styles.processIcon}>3</div>
            <div>{t("landing.spread design")}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProcessSection;
